export interface DoppeActionFullName {
    firstName: string;
    lastName: string;
}

export function doppeActionFullNameGetName(name: DoppeActionFullName): string {
    return `${name.firstName} ${name.lastName}`
}

